export default {
    title: `Maintenance en cours`,
    text: `Une maintenance est en cours sur la plateforme, réessayer de vous connecter dans quelques minutes.`,
};
